import React, { Component, Fragment } from "react"
import { withRouter } from "react-router-dom"
import styles from "./Hero.css"
import Framer from "../Framer/Framer"
import { FrameAnimation, FrameStates } from "../../constants/consts-types"
import PropTypes from "prop-types"
import {
  getViewPortHeight,
  getViewPortWidth,
  isDesktop,
} from "../../services/service-utils"
import Review from "../Review/Review"
import { TypeListItem } from "../../constants/consts-prop-types"
import { loadImage } from "../../services/service-image-loader"
import CategoryOrSubBrand from "./partials/CategoryOrSubBrand"
import BackgroundImageParallax from "./partials/BackgroundImageParallax"
import HeaderBoldLightSub from "./partials/HeaderBoldLightSub"
import CTAs from "./partials/CTAs"
import HeroVideoVideo from "./partials/HeroVideoPlayer";

class HeroSection extends Component {
  static propTypes = {
    data: TypeListItem,
    frameFrom: PropTypes.string,
    frameTo: PropTypes.string,
    frameLeave: PropTypes.string,
  }

  static defaultProps = {
    frameFrom: FrameStates.INIT_EXHIBITION,
    frameTo: FrameStates.EXHIBITION,
    frameLeave: FrameStates.LEAVE_EXHIBITION,
  }

  constructor(props) {
    super(props)

    this.state = {
      frame: props.frameFrom,
      imageSrc: null,
      isDesktop: isDesktop(),
      viewportWidth: getViewPortWidth(),
      viewportHeight: getViewPortHeight(),
    }

    this.onScroll = this.onScroll.bind(this)
    this.onResize = this.onResize.bind(this)
    this.moveHero = this.moveHero.bind(this)
    this.renderReview = this.renderReview.bind(this)
  }

  componentDidMount() {
    this.resetText()

    window.addEventListener("scroll", this.onScroll)
    window.addEventListener("resize", this.onResize)

    loadImage(this.props.data.image_url, this)

    const videoId =
      this.props.data && this.props.data.video && this.props.data.video.video_id

    setTimeout(
      () => {
        if (this.mainNode) {
          this.setState(
            {
              frame: this.props.frameTo,
            },
            this.enterText
          )
        }
      },
      videoId ? 0 : FrameAnimation.ENTER_DELAY
    )
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll)
    window.removeEventListener("resize", this.onResize)
  }

  componentDidUpdate(prevProps) {
    if (this.props.data.image_url !== prevProps.data.image_url) {
      loadImage(this.props.data.image_url, this)
    }
  }

  onResize() {
    if (this.state.viewportWidth === getViewPortWidth()) return

    this.setState({
      isDesktop: isDesktop(),
      viewportWidth: getViewPortWidth(),
      viewportHeight: getViewPortHeight(),
    })
  }

  onScroll() {
    window.requestAnimationFrame(this.moveHero)
  }

  resetText() {
    window.TweenLite.set(this.nodeCat, {
      opacity: 0,
      transform: "translateX(20px)",
    })
    window.TweenLite.set(this.nodeHead, {
      opacity: 0,
      transform: "translateX(20px)",
    })
    if (this.nodeCTAs)
      window.TweenLite.set(this.nodeCTAs, {
        opacity: 0,
        transform: "translateX(20px)",
      })
  }

  enterText() {
    const time = 0.9
    const del = "-=.4"
    this.tl = new window.TimelineLite()
    this.tl.stop()
    if (this.nodeCat)
      this.tl.add(
        window.TweenLite.to(this.nodeCat, time, {
          opacity: 1,
          transform: "translateX(0)",
        }),
        del
      )
    if (this.nodeHead)
      this.tl.add(
        window.TweenLite.to(this.nodeHead, time, {
          opacity: 1,
          transform: "translateX(0)",
        }),
        del
      )
    if (this.nodeCTAs)
      this.tl.add(
        window.TweenLite.to(this.nodeCTAs, time, {
          opacity: 1,
          transform: "translateX(0)",
        }),
        del
      )
    window.TweenLite.to(this.tl, 2, { progress: 1, delay: 0.25 })
  }

  moveHero() {
    this.setState({
      offsetY: Math.min(window.scrollY / 8, 150),
    })
  }

  renderReview(review, idx, className, styleReviewWrappers) {
    return (
      <div key={idx} className={className} style={styleReviewWrappers}>
        <Review data={review} />
      </div>
    )
  }

  render() {
    const { currentRoute } = this.props
    const subBrand = currentRoute.section.name
    const { image_no_cropping } = currentRoute || {}

    const {
      category,
      header_bold,
      header_light,
      header_sub,
      cta_primary,
      cta_secondary,
      colors,
      reviews,
      url,
      video,
    } = this.props.data

    const { imageSrc, viewportHeight, frame, isDesktop } = this.state

    const hasReviews = Boolean(reviews && reviews.length > 0)

    const stylesHero = {
      // height: `calc(${viewportHeight + (hasReviews ? 200 : 0)}px + ${(hasReviews ? '10rem' : '0')})`,
      // height: `calc(100vh + 200px + 2rem)`,
      ...(image_no_cropping
        ? {}
        : { height: `${viewportHeight + (hasReviews ? 200 : 0)}px` }),
      color: colors && colors.foreground ? colors.foreground : "",
      backgroundColor: colors && colors.background ? colors.background : "",
    }

    const styleReviewWrappers = isDesktop
      ? {
          height: "100%",
        }
      : {}

    const videoId = video && video.video_id

    return (
      <section
        ref={(node) => (this.mainNode = node)}
        className={`
          ${
            hasReviews
              ? styles.HeroExhibitionReviews
              : `${styles.Hero} ${styles.HeroExhibition}`
          }
          ${image_no_cropping ? styles.imageNoCropping : ""}
        `}
        style={stylesHero}
      >
        {videoId ? (
          <HeroVideoVideo video={video} />
        ) : (
          <Fragment>
            <Framer state={frame} colors={colors} />
            {!image_no_cropping && (
              <BackgroundImageParallax imageSrc={imageSrc} />
            )}
          </Fragment>
        )}

        <article className={styles.content}>
          {/* <div className={image_no_cropping ? 'container-fluid' : ''}> */}
          <div className="container-fluid">
            <div className={`row ${styles.contentLayout}`}>
              <div
                className={`${
                  image_no_cropping ? "col-md-6" : "h-full col-xs-12"
                }`}
              >
                <div className={styles.frontContainerFluid}>
                  <div className="row">
                    <div
                      className={`col-xs-11 ${
                        !image_no_cropping ? "col-md-5" : ""
                      }`}
                    >
                      <CategoryOrSubBrand
                        ref={(node) => (this.nodeCat = node)}
                        category={category}
                        subBrand={subBrand}
                        url={url}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div
                      className={`col-xs-11 ${
                        !image_no_cropping ? "col-md-5" : ""
                      }`}
                    >
                      <HeaderBoldLightSub
                        ref={(node) => (this.nodeHead = node)}
                        header_bold={header_bold}
                        header_light={header_light}
                        header_sub={header_sub}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div
                      className={`col-xs-11 ${
                        !image_no_cropping ? "col-md-5" : ""
                      }`}
                    >
                      <CTAs
                        ref={(node) => (this.nodeCTAs = node)}
                        cta_primary={cta_primary}
                        cta_secondary={cta_secondary}
                        cta_title={header_bold}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {image_no_cropping && !isDesktop && (
                <img
                  src={imageSrc}
                  alt=""
                  className={styles.imageNotToCrop}
                  style={{ opacity: imageSrc ? 1 : 0 }}
                />
              )}

              {image_no_cropping && (
                <div className={`col-md-6`}>
                  <div
                    className={styles.imageNoCroppingContainer}
                    style={
                      imageSrc && {
                        opacity: 1,
                        backgroundImage: `url(${imageSrc})`,
                      }
                    }
                  >
                    {/* placeholder for image */}
                  </div>
                </div>
              )}
            </div>
          </div>
        </article>

        {hasReviews &&
          imageSrc && ( // imageSrc to avoid content jumping around
            <div className={styles.reviews}>
              <div
                className={`${
                  isDesktop || !image_no_cropping ? "container-fluid" : ""
                }`}
              >
                <div className="row" style={{ height: "100%" }}>
                  {!image_no_cropping && (
                    <div className="col-xs-0 col-md-5"></div>
                  )}
                  <div
                    className="col-md-6"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    <div className="row">
                      {reviews.map((review, idx) =>
                        this.renderReview(
                          review,
                          idx,
                          `${styles.reviewItem} ${
                            image_no_cropping
                              ? "col-xs-8 col-xs-offset-1 col-md-offset-0"
                              : "col-xs-10 col-md-2 col-md-offset-2"
                          } col-md-4`,
                          styleReviewWrappers
                        )
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.imageNoCroppingContainer}>
                {/* To match layout on above article */}
              </div>
            </div>
          )}
      </section>
    );
  }
}

export default withRouter(HeroSection)



// WEBPACK FOOTER //
// ./src/components/Hero/HeroExhibition.js